import React from "react";
import { Send } from "lucide-react";
import GlobalDetailDrawer from "modules/swiftboard/components/GlobalDetailDrawer";
import LocalDateTime from "services/date-converter";
import ActiveBadge from "../../../components/ActiveBadge";
import JsonBlock from "../../../components/JsonBlock";
import { phaseText, rateLimitText } from "../features/channel.utils";

// Read-only view of one channel (a row of the list).
export default function ChannelViewDrawer({ record, onClose }) {
  const sections = [
    {
      title: "Channel",
      fields: [
        { label: "Name", value: record.name || "—" },
        { label: "Key", value: <span className="font-mono">{record.channel_key}</span> },
        { label: "Sending", value: phaseText(record.phase) },
        { label: "Icon", value: record.icon || "—" },
        { label: "Digest", value: record.supports_digest ? "Yes" : "No" },
        { label: "HTML content", value: record.supports_html ? "Yes" : "No" },
        { label: "Rate limit", value: rateLimitText(record.rate_limit_per_min) },
        { label: "Templates", value: record.template_count ?? 0 },
        { label: "Sort order", value: record.sort_order ?? 0 },
        { label: "Status", value: <ActiveBadge active={record.is_activated} /> },
        { label: "Updated", value: record.updated_date ? <LocalDateTime utcTime={record.updated_date} /> : "—" },
        { label: "Description", value: record.description || "—" },
      ],
    },
    { title: "Template schema", fields: [{ value: <JsonBlock value={record.template_schema} /> }] },
    { title: "Config schema", fields: [{ value: <JsonBlock value={record.config_schema} /> }] },
  ];

  return <GlobalDetailDrawer open onClose={onClose} title={record.name || "Channel"} subtitle={record.channel_key} icon={<Send size={20} />} sections={sections} />;
}
